import { Component } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'app-guide-five',
  templateUrl: './guide-five.component.html',
})
export class GuideFiveComponent {
  brainstorms = [
    {
      index: 1,
      title: 'Title 1',
    },
    {
      index: 2,
      title: 'Title 2',
    },
    {
      index: 3,
      title: 'Title 3',
    },
    {
      index: 4,
      title: 'Title 4',
    },
    {
      index: 5,
      title: 'Title 5',
    },
  ];

  constructor(private router: Router) {}

  onSubmit() {
    this.router.navigate(['step-six']).then();
  }
}
